import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialCarousel = ({ testimonials }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials?.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials?.length - 1 ? 0 : prev + 1));
  };

  const currentTestimonial = testimonials?.[currentIndex];

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8 lg:p-10">
      <div className="text-center mb-8 md:mb-10">
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-headline font-bold text-foreground mb-4">
          Client Success Stories
        </h3>
        <p className="text-base md:text-lg text-muted-foreground">
          Hear from those who have experienced our services
        </p>
      </div>
      <div className="relative max-w-4xl mx-auto">
        <div className="bg-muted rounded-2xl p-8 md:p-10 lg:p-12">
          <div className="flex items-start gap-4 mb-6">
            <Icon name="Quote" size={48} color="var(--color-primary)" className="flex-shrink-0 opacity-50" />
          </div>

          <p className="text-lg md:text-xl text-foreground leading-relaxed mb-8 italic">
            "{currentTestimonial?.quote}"
          </p>

          <div className="flex items-center gap-4">
            <div className="w-16 h-16 md:w-20 md:h-20 rounded-full overflow-hidden flex-shrink-0">
              <Image
                src={currentTestimonial?.image}
                alt={currentTestimonial?.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1">
              <h4 className="text-lg font-headline font-bold text-foreground">
                {currentTestimonial?.name}
              </h4>
              <p className="text-sm text-muted-foreground">
                {currentTestimonial?.role}
              </p>
              <p className="text-sm text-primary font-medium mt-1">
                {currentTestimonial?.organization}
              </p>
            </div>
            <div className="hidden md:flex items-center gap-1">
              {[...Array(5)]?.map((_, i) => (
                <Icon
                  key={i}
                  name="Star"
                  size={20}
                  color="var(--color-warning)"
                  className="fill-current"
                />
              ))}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-center gap-4 mt-8">
          <button
            onClick={handlePrevious}
            className="w-12 h-12 rounded-full border-2 border-border hover:border-primary hover:bg-primary/10 flex items-center justify-center transition-all duration-300"
            aria-label="Previous testimonial"
          >
            <Icon name="ChevronLeft" size={24} />
          </button>

          <div className="flex items-center gap-2">
            {testimonials?.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex 
                    ? 'w-8 bg-primary' :'w-2 bg-border hover:bg-primary/50'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>

          <button
            onClick={handleNext}
            className="w-12 h-12 rounded-full border-2 border-border hover:border-primary hover:bg-primary/10 flex items-center justify-center transition-all duration-300"
            aria-label="Next testimonial"
          >
            <Icon name="ChevronRight" size={24} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCarousel;